import { watch, onScopeDispose } from 'vue';
import { storeToRefs } from 'pinia';
import { useKeybindStore } from '../stores/keybindStore';
import { KeyboardActions } from '../domain/keyboardActions';

export function useOnKeyboardAction(
  action: KeyboardActions,
  onDown: () => void,
  onUp?: () => void,
) {
  const store = useKeybindStore();
  const { keyboardAction, } = storeToRefs(store);

  // fires once per physical keydown (ignores OS auto-repeat)
  const stopDown = watch(keyboardAction, (val) => {
    if (val.action === action) {
      onDown();
    }
  });

  // fires on keyup (and on window blur, since the store clears activeActions there)
  const stopUp = onUp
    ? watch(
        () => store.isActionHeld(action),
        (isHeld, wasHeld) => {
          if (wasHeld && !isHeld) {
            onUp();
          }
        },
      )
    : undefined;

  onScopeDispose(() => {
    stopDown();
    stopUp?.();
  });
}
